/**
 * Validates SSO JWT and target URL before posting the hidden form.
 * Keeps token handling out of React hooks and colocated with the SSO saga.
 */
export function assertValidSsoJwtAndTargetUrl(jwt, targetUrl) {
  if (typeof jwt !== 'string' || jwt.split('.').length !== 3 || jwt.length > 8192) {
    throw new Error('sso_invalid_jwt_format');
  }
  if (!/^https?:\/\//.test(targetUrl)) {
    throw new Error('sso_invalid_target_url');
  }
}

/**
 * POSTs the SSO JWT to the target platform via a transient hidden form.
 */
export function submitJwtForm(jwt, targetUrl) {
  assertValidSsoJwtAndTargetUrl(jwt, targetUrl);

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = targetUrl;
  form.style.display = 'none';

  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'jwt';
  input.value = jwt;
  form.appendChild(input);

  document.body.appendChild(form);
  form.submit();
}
